<script lang="ts">
    // store
    import {
        balance,
        autoBetStarted,
        autoBetCount,
        lastSelectedAutoBetCount,
        stopAutoBet,
        isPlayAllowed,
        currency,
        allowToBet,
        gameState,
        isUndoResetHistory
    } from '@src/store';
    import {
        isCrossModalOpened,
        isAutoplayModalOpened,
        isBetModalOpened,
        currentTabMainMenu,
        closeAllModals,
        userSettings
    } from '@src/store/ui';
    import { currencyDecimal } from '@root/src/store/misc';
    import {
        availableChips,
        chipPrice,
        selectedChipIndex,
        showBetSizeChips,
        chipBetPerColor
    } from '@root/src/store/chips';
    import { double, resetBets, undoBet, getBetPerColor } from '@root/src/betting/betting';
    import { EventEmitterInstance } from '@src/utils/event-emitter';
    import { BONUS_GAMES, MODAL_TABS } from '@src/constants';
    import { allowToSkip } from '@src/store';

    // components
    import CenterContentControls from './center-content/center-content-controls.svelte';
    import LeftContentControls from './left-content/left-content-controls.svelte';
    import RightContentControls from './right-content/right-content-controls.svelte';
    import CenterContentControlsBonusGames from './center-content/center-content-controls-bonus-games.svelte';

    const makeBet = () => {
        closeAllModals();
        EventEmitterInstance.emit('play');
    };

    const skipGameHandler = () => {
        EventEmitterInstance.emit('skip-game');
        EventEmitterInstance.emit('analytics-skip-game');
        closeAllModals();
    };

    const clickAutoplay = () => {
        if (!$autoBetStarted) {
            closeAllModals();
            $isAutoplayModalOpened = true;
            return;
        }
        stopAutoBet();
        $lastSelectedAutoBetCount = null;
    };

    const betModalHandler = () => {
        closeAllModals();
        $isBetModalOpened = true;
    };

    const menuHandler = () => {
        closeAllModals();
        $isCrossModalOpened = true;
        $currentTabMainMenu = MODAL_TABS.SETTINGS;
    };

    const undo = () => {
        undoBet();
        chipBetPerColor.set(getBetPerColor());
        EventEmitterInstance.emit('analytics-bet-ui-interaction', 'undo');
    };

    const reset = () => {
        resetBets();
        chipBetPerColor.set(getBetPerColor());
        isUndoResetHistory.set(false);
        EventEmitterInstance.emit('analytics-bet-ui-interaction', 'rebet');
    };

    const multiplyX2 = () => {
        double();
        chipBetPerColor.set(getBetPerColor());
        EventEmitterInstance.emit('analytics-bet-ui-interaction', 'x2');
    };

    const toggleShowBetSizeChips = () => {
        showBetSizeChips.update(value => !value);
    };

    // fix bug CB-1679
    $: if ($autoBetCount === 0) {
        $lastSelectedAutoBetCount = null;
    }

    $: isBonusGame =
        $gameState === BONUS_GAMES.BALL_SPIN ||
        $gameState === BONUS_GAMES.PLINKO ||
        $gameState === BONUS_GAMES.CASH_REELS ||
        $gameState === BONUS_GAMES.FORTUNE_WHEEL;
</script>

<div class="action-buttons relative flex w-full place-items-center justify-center gap-x-2 desktop:flex desktop:gap-x-6">
    <LeftContentControls
        currency={$currency}
        isMuted={!$userSettings.soundEnabled && !$userSettings.musicEnabled}
        chipPrice={$chipPrice}
        on:menu={menuHandler}
    />

    <div class="w-full desktop:w-[343px]">
        {#if isBonusGame}
            <CenterContentControlsBonusGames allowToStart={$allowToBet} typeBonusGame={$gameState} on:click={makeBet} />
        {:else}
            <CenterContentControls
                balance={$balance}
                allowToPlay={$isPlayAllowed}
                allowToSkip={$allowToSkip}
                autoBetCount={$autoBetCount}
                selectedChipAmount={$availableChips[$selectedChipIndex]}
                selectedChipIndex={$selectedChipIndex}
                currency={$currency}
                decimalValue={$currencyDecimal}
                chipPrice={$chipPrice}
                on:bet-modal={betModalHandler}
                on:start-game={makeBet}
                on:skip-game={skipGameHandler}
                on:autoplay-modal={clickAutoplay}
                on:menu={menuHandler}
                on:undo={undo}
                on:reset={reset}
                on:multiply-x2={multiplyX2}
                on:toggle-bet-size-chips={toggleShowBetSizeChips}
            />
        {/if}
    </div>

    <RightContentControls currency={$currency} balance={$balance} />
</div>
